module.exports = __webpack_public_path__ + "images/car_normal_1.f3bd10ee3a89487c9d4dc4f70a0910d0.svg";